import React from 'react';
import { Shield, UserCheck, CheckCircle, BarChart3, Check } from 'lucide-react';
import './Rankings.css';

const Rankings: React.FC = () => {
  return (
    <section className="rankings" id="rankings">
      <div className="rankings__container">
        <div className="rankings__inner">
          <div className="rankings__content">
            <div className="section-badge">Skill Profile</div>
            <h2>Share your level,<br /><span className="text-gradient">find the right game</span></h2>
            <p>RalliPB profiles include a self-selected skill rating and can display rating data when it is available on the account. The goal is simple: help players understand level and coordinate better games.</p>

            <div className="rankings__features">
              <div className="rankings__feature">
                <div className="rankings__feature-icon">
                  <UserCheck size={20} color="#6BA314" />
                </div>
                <div>
                  <strong>Self Rating</strong>
                  <p>Choose a skill level from 1.0 to 5.5 and update it from your profile as your game changes.</p>
                </div>
              </div>
              <div className="rankings__feature">
                <div className="rankings__feature-icon">
                  <BarChart3 size={20} color="#0088FF" />
                </div>
                <div>
                  <strong>Rating Display</strong>
                  <p>Show rating information on your profile when rating data is available for your account.</p>
                </div>
              </div>
              <div className="rankings__feature">
                <div className="rankings__feature-icon">
                  <Shield size={20} color="#FF9900" />
                </div>
                <div>
                  <strong>Player Context</strong>
                  <p>Skill badges appear across player search, friends, court activity, and profile views.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="rankings__visual">
            <div className="rating-card">
              <div className="rating-card__header">
                <BarChart3 size={20} color="#0088FF" />
                <span>Player Skill</span>
                <CheckCircle size={16} color="#0088FF" />
              </div>
              <div className="rating-card__body">
                <div className="rating-card__value">4.0</div>
                <div className="rating-card__type">Self Rating</div>
              </div>
              <div className="rating-card__body">
                <div className="rating-card__value">--</div>
                <div className="rating-card__type">Rating when available</div>
              </div>
              <div className="rating-card__footer">
                <span className="rating-card__badge">
                  <Check size={12} />
                  Profile
                </span>
                <span className="rating-card__meta">Editable in app</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Rankings;
